<template>
  <div>
    <DefaultLayout>
      <template slot="title">
        {{ "signinPage.signIn" | t }}
      </template>
      <template slot="contents">
        <div class="columns is-centered">
          <div v-if="!isLoading" class="column">
            <form @submit.prevent="signInAndMoveToDashboard">
              <input v-model="email" class="input" type="email" :placeholder="$t('signinPage.email')" required />
              <input
                v-model="password"
                class="input"
                type="password"
                :placeholder="$t('signinPage.password')"
                required
              />
              <p v-if="errorStatus" class="help is-danger">
                {{ "signinPage.invalid" | t }}
              </p>
              <button type="submit" class="button is-primary">
                {{ "signinPage.signIn" | t }}
              </button>
            </form>
            <section class="forgot-password">
              <span>{{ "signinPage.forgotPassword" | t }}</span
              ><a href="mailto:japan@virtusize.com">japan@virtusize.com</a>
            </section>
          </div>
        </div>
      </template>
    </DefaultLayout>
    <VsLoader :visible="isLoading" />
  </div>
</template>

<script>
import DefaultLayout from "@/layouts/Default";
import { mapActions } from "vuex";

export default {
  components: {
    DefaultLayout,
  },
  data() {
    return {
      email: "",
      password: "",
      errorStatus: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions("user", ["signIn"]),
    async signInAndMoveToDashboard() {
      this.isLoading = true;
      this.errorStatus = false;
      try {
        await this.signIn({
          email: this.email,
          password: this.password,
        });
        this.$router.push({ name: "dashboard" });
      } catch (e) {
        this.errorStatus = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input {
  width: 370px;
  height: 50px;
  margin-top: 10px;
  font-size: 16px;
}

.button {
  width: 120px;
  height: 50px;
  margin-top: 15px;
}

.help {
  text-align: left;
}

.forgot-password {
  width: 60%;
  margin: 20px auto 0;
  font-size: 13px;
}
</style>
